export function openSidebar() {
  if (typeof window !== 'undefined') {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.setProperty('--SideNavigation-slideIn', '1');
  }
}

export function closeSidebar() {
  if (typeof window !== 'undefined') {
    document.documentElement.style.removeProperty('--SideNavigation-slideIn');
    document.body.style.removeProperty('overflow');
  }
}

export function toggleSidebar() {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const slideIn = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue('--SideNavigation-slideIn');
    if (slideIn) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }
}

export function openMessagesPane() {
  if (typeof window !== 'undefined') {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.setProperty('--MessagesPane-slideIn', '1');
  }
}

export function closeMessagesPane() {
  if (typeof window !== 'undefined') {
    document.documentElement.style.removeProperty('--MessagesPane-slideIn');
    document.body.style.removeProperty('overflow');
  }
}

export function toggleMessagesPane() {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const slideIn = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue('--MessagesPane-slideIn');
    if (slideIn) {
      closeMessagesPane();
    } else {
      openMessagesPane();
    }
  }
}


export const adjustTime = (dateString, hoursToSubtract = 5) => {
  if (!dateString) return null;
  
  const date = new Date(dateString);
  date.setHours(date.getHours() - hoursToSubtract);
  
  return date;
};

// Маска телефона РФ: любой ввод → "+7 (XXX) XXX-XX-XX" (баг #1).
export function formatPhoneRu(input, prev) {
  let digits = (input || '').replace(/\D/g, '');
  // Backspace «застрял» на форматирующем символе: строка стала короче, но цифр столько же —
  // значит удалили ')', '-', ' ' или '('. Убираем последнюю цифру, чтобы удаление шло из конца.
  if (prev !== undefined && prev !== null) {
    const prevDigits = (prev || '').replace(/\D/g, '');
    if ((input || '').length < prev.length && digits.length === prevDigits.length) {
      digits = digits.slice(0, -1);
    }
  }
  if (!digits) return '';                       // пусто → пусто (виден placeholder)
  if (digits.startsWith('8')) digits = '7' + digits.slice(1);
  if (!digits.startsWith('7')) digits = '7' + digits;
  digits = digits.slice(0, 11);                 // 7 + 10 цифр
  const d = digits.slice(1);                    // 10 цифр номера
  let out = '+7';
  if (d.length > 0) out += ' (' + d.slice(0, 3);
  if (d.length >= 3) out += ')';
  if (d.length > 3) out += ' ' + d.slice(3, 6);
  if (d.length > 6) out += '-' + d.slice(6, 8);
  if (d.length > 8) out += '-' + d.slice(8, 10);
  return out;
}

// Кол-во цифр в телефоне (для валидации: РФ = 11).
export function phoneDigitsCount(value) {
  return (value || '').replace(/\D/g, '').length;
}